import { render, staticRenderFns } from "./PartnersMediumSize.vue?vue&type=template&id=d730dad8&"
import script from "./PartnersMediumSize.vue?vue&type=script&lang=js&"
export * from "./PartnersMediumSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports